import React from "react";

var chargeSvg = function chargeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 4h14c.552 0 1 .407 1 .91v8.18c0 .503-.448.91-1 .91H1c-.552 0-1-.407-1-.91V4.91C0 4.406.448 4 1 4zm1-3h12a1 1 0 0 1 1 1v1H1V2a1 1 0 0 1 1-1zm6 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
  }));
};

chargeSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var charge = {
  category: 'icon',
  colorable: true,
  name: 'charge',
  svg: chargeSvg
};